import styled from "styled-components";
import { primaryColor } from "styles/variables";

export const ErrorWrapper = styled.div`
  position: relative;
  color: ${primaryColor};
  display: flex;
  justify-content: center;
  inset: 20% 0;
  margin: auto;
`;
